import React from 'react';
import { useModalStore } from '@/store';
import ModelCardView from './ModelCardView';

// Keep existing catalog behavior; the presentation can also run without the
// Expo routing/store graph in other native hosts.
export default React.memo(function ModelCard(props) {
  const openModal = useModalStore(state => state.actions.openModal);
  return <ModelCardView {...props} onDetailsPress={modelId => openModal('ModelDetailsModal', { modelId })} />;
});
